import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { Animated, View } from 'react-native';
import { ChoiceItemSwitchView } from './ChoiceItemSwitchView';
import { ChoiceItemSelectView } from './ChoiceItemSelectView';
import { ChoiceItemTextView } from './ChoiceItemTextView';
import { ChoiceItemCheckboxView } from './ChoiceItemCheckboxView';
import { ChoiceItemInputView } from './ChoiceItemInputView';
import { ChoiceItemStepperView } from './ChoiceItemStepperView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
const ChoiceItems = {
    checkbox: (props) => (_jsx(ChoiceItemCheckboxView, Object.assign({}, props.value, { testID: props.testID, light: props.light, onChange: props.onChange, children: props.children }))),
    check: (props) => (_jsx(ChoiceItemSwitchView, Object.assign({}, props.value, { testID: props.testID, light: props.light, onChange: props.onChange, children: props.children }))),
    select: (props) => (_jsx(ChoiceItemSelectView, Object.assign({}, props.value, { testID: props.testID, light: props.light, onChange: props.onChange, children: props.children }))),
    radio: (props) => (_jsx(ChoiceItemSelectView, Object.assign({}, props.value, { testID: props.testID, light: props.light, onChange: props.onChange, children: props.children }))),
    input: (props) => (_jsx(ChoiceItemInputView, Object.assign({}, props.value, { testID: props.testID, light: props.light, onChange: props.onChange, children: props.children }))),
    text: (props) => (_jsx(ChoiceItemTextView, Object.assign({}, props.value, { testID: props.testID, light: props.light, onChange: props.onChange, children: props.children }))),
    stepper: (props) => (_jsx(ChoiceItemStepperView, Object.assign({}, props.value, { testID: props.testID, light: props.light, onChange: props.onChange, children: props.children }))),
};
export const ChoiceItemView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.choiceItem,
    style: {
        list: {
            marginTop: 10
        }
    }
})((props) => {
    var _a, _b;
    const [isOpen, setIsOpen] = useState(false);
    const animation = useRef(new Animated.Value(props.value.value ? 1 : 0)).current;
    const handleChange = useCallback((id, value) => {
        var _a, _b;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, id, value);
        (_b = props.onItemChange) === null || _b === void 0 ? void 0 : _b.call(props, Object.assign(Object.assign({}, props.value), { value }));
    }, [props.onChange, props.onItemChange, props.value]);
    const handleDeepChange = useCallback((id, value) => {
        var _a, _b;
        const update = Object.assign(Object.assign({}, props.value), { choice_items: (_a = props.value.choice_items) === null || _a === void 0 ? void 0 : _a.map(item => {
                return item.id === id
                    ? Object.assign(Object.assign({}, item), { value }) : item;
            }) });
        (_b = props.onItemChange) === null || _b === void 0 ? void 0 : _b.call(props, update);
    }, [props.onItemChange, props.value]);
    useEffect(() => {
        if (props.value.value) {
            setIsOpen(true);
            Animated.timing(animation, {
                useNativeDriver: false,
                toValue: 1,
                duration: 200
            }).start();
            return;
        }
        Animated.timing(animation, {
            useNativeDriver: false,
            toValue: 0,
            duration: 200
        }).start(() => {
            setIsOpen(false);
        });
    }, [props.value.value]);
    if (!ChoiceItems[props.value.type]) {
        console.warn(`Their is no component for choice item ${JSON.stringify(props.value)}`);
        return null;
    }
    const ChoiceItem = ChoiceItems[props.value.type];
    return (_jsxs(View, { children: [_jsx(ChoiceItem, Object.assign({}, props, { light: props.light, onChange: handleChange })), isOpen && (props.value.choice_items || []).length > 0 && (_jsx(Animated.View, { style: [(_a = props.style) === null || _a === void 0 ? void 0 : _a.list, { opacity: animation }], children: (_b = props.value.choice_items) === null || _b === void 0 ? void 0 : _b.map((choiceItem) => (_jsx(ChoiceItemView, { light: props.light, value: choiceItem, onChange: handleDeepChange }, choiceItem.id))) }))] }));
});
